import { RootStore } from '@store';
import { action, computed, makeObservable, observable } from 'mobx';
import { PurseType } from 'types/enums';
import { AnimationInGame, SoundInGame, UtilsLocalStorage } from './localStorage';
import { inject } from 'react-ioc';
import { SoundService } from './soundService';

// TODO: убрать настройки игры в отдельный сервис,  ведь для всех игр одна настройка  - sound, animation
export class GameService {
    protected readonly rootStore: RootStore;
    protected readonly _soundService: SoundService;
    protected io: typeof io.Socket | null;

    @observable isLoading: boolean = true;
    @observable animation: boolean = false;

    constructor(rootStore: RootStore) {
        makeObservable(this);
        this.rootStore = inject<RootStore>(this, RootStore);
        this._soundService = inject<SoundService>(this, SoundService);
        this.io = null;
        this.getAnimationValueOnInitialization();
    }

    @computed
    public get userBalance() {
        return this.rootStore.userStore.balance;
    }

    @computed
    public get currency() {
        return this.rootStore.userStore.currency as PurseType;
    }

    @computed
    public get sound(): boolean {
        return this._soundService.isSound;
    }

    @action
    public gameLoaded() {
        this.isLoading = false;
    }

    @action
    public switchSound() {
        const sound = !this.sound;
        this._soundService.playWithoutSound(sound);
        UtilsLocalStorage.setSoundInGame(sound ? SoundInGame.ON : SoundInGame.OFF);
    }

    @action
    public switchAnimation() {
        const animation = !this.animation;
        this.animation = animation;
        UtilsLocalStorage.setAnimationInGame(animation ? AnimationInGame.VISIBLE : AnimationInGame.HIDDEN);
    }

    @action
    protected setCurrency(currency) {
        this.rootStore.userStore.setCurrency(currency);
    }

    @action
    private getAnimationValueOnInitialization() {
        if (UtilsLocalStorage.animationInGame) {
            this.animation = UtilsLocalStorage.animationInGame === AnimationInGame.VISIBLE ? true : false;
            return;
        }
        this.animation = this.isProductiveDevice;
        UtilsLocalStorage.setAnimationInGame(this.animation ? AnimationInGame.VISIBLE : AnimationInGame.HIDDEN);
    }

    private get isProductiveDevice(): boolean {
        return this.crutchForPerformance() < 5;
    }

    private crutchForPerformance(): number {
        const benchArray: string[] = [];
        const start = performance.now();
        for (let i = 0; i < 5000; i++) {
            benchArray[i] = `${(i * i * i) / 2}`;
        }
        const end = performance.now();
        const diff = end - start;
        return diff;
    }

    public connect(game) {
        if (this.io) this.io.close();
        const { userStore, websocketGameService } = this.rootStore;
        const { token, operatorId } = userStore;
        websocketGameService.init(operatorId, game, token);
        this.io = websocketGameService.ws;
        this.io?.on('connect', this.gameLoaded.bind(this));
    }
}
